// Calculate dosage for immunity formula
export function calculateImmunityDosage(answers) {
    // 黄芪 (2-3g) - 补气固表
    let huangqi = 2;

    if (answers.mainReason === 'frequent_cold') {
        if (answers.coldFrequency === '5+') {
            huangqi = 3;
        } else if (answers.coldFrequency === '3-4') {
            huangqi = 2.5;
        } else {
            huangqi = 2;
        }
        // 如果容易出汗，增加剂量
        if (answers.coldSymptoms?.includes('sweating')) {
            huangqi = Math.min(3, huangqi + 0.5);
        }
    } else if (answers.mainReason === 'fatigue') {
        if (answers.fatigueDuration === '>6months') {
            huangqi = 3;
        } else if (answers.fatigueDuration === '3-6months') {
            huangqi = 2.5;
        } else {
            huangqi = 2;
        }
    } else if (answers.mainReason === 'seasonal') {
        huangqi = 2.5;
    } else {
        // prevention
        huangqi = 2;
    }

    // 如果有气短症状，增加黄芪
    if (answers.otherSymptoms?.includes('shortness_breath')) {
        huangqi = Math.min(3, huangqi + 0.5);
    }

    // 西洋参 (1-2g) - 补气养阴
    let xiyangshen = 1;

    const hasYinDeficiency =
        answers.constitution?.includes('dry_mouth') ||
        answers.sleepQuality === 'poor' ||
        answers.stress === 'high';

    if (hasYinDeficiency) {
        const yinCount = [
            answers.constitution?.includes('dry_mouth'),
            answers.sleepQuality === 'poor',
            answers.stress === 'high',
            answers.fatigueType?.includes('mental')
        ].filter(Boolean).length;

        if (yinCount >= 3) {
            xiyangshen = 2;
        } else if (yinCount >= 1) {
            xiyangshen = 1.5;
        }
    }

    // 麦冬 (2-3g) - 养阴润燥
    let maidong = 2;

    const hasStrongYinDeficiency =
        answers.constitution?.includes('dry_mouth') ||
        answers.constitution?.includes('heat_intolerance') ||
        answers.constitution?.includes('night_sweat');

    if (hasStrongYinDeficiency) {
        const strongYinCount = [
            answers.constitution?.includes('dry_mouth'),
            answers.constitution?.includes('heat_intolerance'),
            answers.constitution?.includes('night_sweat')
        ].filter(Boolean).length;

        if (strongYinCount >= 2) {
            maidong = 3;
        } else {
            maidong = 2.5;
        }
    }

    // 计算总剂量等级
    const total = huangqi + xiyangshen + maidong;
    let level;
    if (total <= 5.5) level = 'light';
    else if (total <= 7) level = 'medium';
    else level = 'heavy';

    return {
        huangqi,
        xiyangshen,
        maidong,
        level,
        total
    };
}

// Determine review status
export function getImmunityReviewStatus(answers, dosage) {
    // Red flags
    if (answers.safety && !answers.safety.includes('none')) {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Health risk factors detected, professional review required.'
        };
    }

    if (answers.demographics?.age === 'other') {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Age factor requires professional confirmation.'
        };
    }

    // Yellow flags
    if (answers.coldFrequency === '5+') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'High frequency of colds, priority assessment recommended.'
        };
    }

    if (answers.fatigueDuration === '>6months') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Chronic fatigue, priority assessment recommended.'
        };
    }

    // Green
    return {
        status: 'green',
        label: 'Auto Approved',
        message: 'Formula generated, proceeding to production.'
    };
}

// Base formula
export const IMMUNITY_BASE_FORMULA = [
    { name: 'Poria Mushroom', amount: '2g' },
    { name: 'Goji berry', amount: '2g' },
    { name: 'Reishi Mushroom', amount: '1g' }
];